import { APPROVE_FOLLOWER, REJECT_FOLLOWER } from "shared/api";
import { AsyncButton, Icon } from "shared/react";
import { callAPI } from "../util/api.js";
import { useFollowingData } from "../util/data.js";

/** Show a bar that shows whether a target user follows the current logged-in user. */
export function FollowsYouNotice({ follower, mods = "" }: { follower: string; mods?: string }): React.ReactElement | null {
	const { status } = useFollowingData(undefined, follower);
	if (status === "blocked")
		return (
			<aside className={`notice notice-error ${mods}`}>
				<span>You blocked this profile</span>
			</aside>
		);
	if (status === "approved")
		return (
			<aside className={`notice notice-success ${mods}`}>
				<span>Follows you</span>
			</aside>
		);
	if (status === "requested")
		return (
			<aside className={`notice ${mods}`}>
				<p className="text-left">Wants to follow you</p>
				<AsyncButton onClick={() => callAPI(APPROVE_FOLLOWER, follower)} mods="button-default" title="Approve follow request">
					Approve
				</AsyncButton>
				<AsyncButton onClick={() => callAPI(REJECT_FOLLOWER, follower)} mods="flex-fit" title="Delete follow request">
					<Icon icon="close" />
				</AsyncButton>
			</aside>
		);
	return null;
}
